import { getRouteApi } from '@tanstack/react-router'
import { CircularProgress } from 'ui/components'

import { ManageLicensePage } from '../../components/ManageLicensePage'
import { useGetLicense } from '../../hooks'

const routeApi = getRouteApi('/_app/licenses/add')

const CreateLicense = () => {
  const { returnUrl, companyId } = routeApi.useSearch()
  const { data, isFetching } = useGetLicense({ licenseId: 0, companyId })

  return (
    <>{!data || isFetching ? <CircularProgress centered /> : <ManageLicensePage data={data} returnUrl={returnUrl} />}</>
  )
}

export default CreateLicense
